// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Select-module__select__RLNKl {\n  border: 2px solid var(--color-border);\n  font-size: var(--font-size-normal);\n  padding: var(--spacing-small);\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/common/components/Select.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;EAC7B,WAAW;AACb","sourcesContent":[".select {\n  border: 2px solid var(--color-border);\n  font-size: var(--font-size-normal);\n  padding: var(--spacing-small);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": "Select-module__select__RLNKl"
};
export default ___CSS_LOADER_EXPORT___;
